import React, {useState} from "react";
import {useHistory} from 'react-router-dom'

import {setPathForRouter} from "@common-helpers/set-rout-path"
import {inputHandler} from "@common-helpers/input-handler"
import {getAnimationDurationClassName} from "@common-helpers/get-animation-duration-class-name"
import {SendUserData} from "@common-helpers/userData"

import {PageHeader} from "@common-layout-components/page-header"
import {PageCounter} from "@common-components/page-counter"
import {NextBtn} from "@common-ui/next-btn-single"
import {Modal} from '@common-components/modal';
import axios from 'axios';
import './style.scss'

export const InputQuestion = ({
                          title = 'Заголовок',
                          subtitle = null,
                          inputPagesConfigNewLayer = null,
                          nextRout,
                          prevRout,
                          nextPageId,
                          prevPageId,
                          componentName,
                          answersOnQuestions,
                          setAnswersOnQuestions,
                          bubbleTitle = 'Заголовок',
                          bubbleSubtitle = 'под заголовок если нужен',
                          inputName = 'inputName',
                          placeholder = 'placeholder',
                          additionalClasses = '',
                          nextCallback,
                          prevCallback,
                          activeProgressBarStep,
                          progressPagesCount,
                          leftPlaceholder,
                          rightPlaceholder,
                          validator
}) => {

    const animationDurationClassName = getAnimationDurationClassName(),
          inputValue = answersOnQuestions[inputName],
          history = useHistory(),
          [error, setError] = useState(''),
          isNextPageDisabled = inputValue === null || inputValue === '' || inputValue === undefined,
          nextOnClick = () => {

            if (typeof validator === 'function') {

                const validatorResult = validator(inputValue)

                if (validatorResult) {
                    setError(validatorResult)
                } else {

                    if(componentName === 'Weight'){
                        SendUserData({
                            click_id: localStorage.getItem('click_id'),
                            weight: Number(answersOnQuestions.weightKg)
                        });
                    }

                    if(componentName === 'Height'){
                        SendUserData({
                            click_id: localStorage.getItem('click_id'),
                            height: answersOnQuestions.heightCm
                        });
                    }

                    nextCallback()
                    setPathForRouter(nextRout, nextPageId, false, history)
                }

            } else {

                nextCallback()
                setPathForRouter(nextRout, nextPageId, false, history)
            }



          },
        clickHandler = (e) => {
            const input = e.target.closest('.input-with-two-placeholder').querySelector('input')

            if (input) {
                input.focus();
            }

        }


    const openModalHandler = async (event) => {
        event.preventDefault()

        try {
            const { data } = await axios.get(event.target.href, {
                headers: { 'x-requested-with': 'XMLHttpRequest' },
                responseType: 'text',
            })

            // create a fake DOM
            const parser = new DOMParser()
            const doc = parser.parseFromString(data, 'text/html')

            // grab only the element you want (adjust selector to your layout)
            const content = doc.querySelector('.main-content')?.innerHTML || data

            setModalContent(content)
            setModalOpen(true)
            // hide progress bar
            const progressBarWrapper = document.querySelector('.step-progress-bar-line-wrapper')
            if (progressBarWrapper) progressBarWrapper.style.display = 'none'

            document.querySelector('.component-scroll-wrapper')?.scrollTo(0, 0)
            document.querySelector('.modal_open')?.scrollTo(0, 0)

        } catch (error) {
            console.error("Failed to load modal content:", error)
        }
    }

    const [modalOpen, setModalOpen] = useState(false)
    const [modalContent, setModalContent] = useState(null)
    const closeModalHandler = () => {
        setModalOpen(false)

        // show progress bar again
        const progressBarWrapper = document.querySelector('.step-progress-bar-line-wrapper')
        if (progressBarWrapper) progressBarWrapper.style.display = 'block'
    }
        return (
        <div className={`content ${animationDurationClassName} ${additionalClasses}`} >

            <div className={`content__inner`} >

                {PageHeader({title, subtitle})}

                            <div className="input-with-two-placeholder" onClick={clickHandler} >
                                <p className={'input-error'}>{error}</p>
                                {inputValue ? null : <span className={'left-placeholder'}>{leftPlaceholder}</span>}

                                <input
                                    type={'number'}
                                    onChange={(e) => inputHandler(e, setAnswersOnQuestions, inputName)}
                                    value={inputValue}
                                />
                                <span className={'right-placeholder'}>
                                    {rightPlaceholder}
                                </span>
                            </div>

                <PageCounter withBtn={true} btnData={{prevRout, prevPageId, prevCallback}} currentPageNumber={activeProgressBarStep} pageQuantity={progressPagesCount}  />
                {/* Footer Disclaimer (like in your other component) */}
                <div className={'footer-disclaimer'}>
                    By using this site, you consent to the use of cookies to help us make it better and you are also agree to our{" "}
                    <a className={'footer-link'} href="/privacy"  onClick={openModalHandler}>privacy policy</a> and{" "}
                    <a className={'footer-link'} href="/terms" onClick={openModalHandler}>service rules</a>.
                </div>
                {NextBtn({nextRout, prevRout, isDisabled: isNextPageDisabled, nextPageId, nextOnClick})}
                {/* Shared Modal */}
                <Modal
                    isOpen={modalOpen}
                    openHandler={closeModalHandler}
                    theme={'big'}
                >
                    {modalContent}
                </Modal>
            </div>

        </div>
    )

}

